import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import CalloutAsset from '#client/components/CalloutAsset';
import PageHeader from '#client/components/PageHeader';
import SingleChoiceSelection from '#client/components/SingleChoiceSelection';
import useFlowState from '#client/hooks/flow/useFlowState';
import useFlowNavigation from '#client/hooks/useFlowNavigation';
import TwoColumnLayout from '#client/layouts/TwoColumnLayout';

export const OPTIONS = {
  zero: 'zero',
  some: 'some',
  lots: 'lots'
};

export const getChoices = (formatMessage) => {
  return Object.entries(OPTIONS).map(([key, value]) => ({
    value,
    label: formatMessage({ id: `shopping.page.businessExperience.option.${key}.label` })
  }));
};

function BusinessExperience({ calloutAssetProps, showSubTitle, hideSkipButton }) {
  const { sizes } = useBreakpoints();
  const { goToNextPage } = useFlowNavigation();
  const { businessInfo, set } = useFlowState();
  const { formatMessage } = useIntl();
  const { isMobile } = sizes;

  const handleOnClick = (option = null) => {
    set('businessInfo.businessExperience', option);
    goToNextPage();
  };

  return (
    <TwoColumnLayout>
      <TwoColumnLayout.SmallColumn>
        <PageHeader
          subtitle={
            showSubTitle && (
              <FormattedMessage id="shopping.page.businessExperience.subtitle.recommended" />
            )
          }
          title={<FormattedMessage id="shopping.page.businessExperience.title" />}
        />
        <SingleChoiceSelection
          defaultValue={OPTIONS.zero}
          options={getChoices(formatMessage)}
          primaryAction={{
            label: formatMessage({ id: 'shopping.page.businessExperience.primaryAction.label' }),
            clickstreamProps: {
              elementName: 'business_experience_primary_action'
            },
            'data-testid': 'business-experience-primary-action',
            onClick: handleOnClick
          }}
          secondaryAction={
            !hideSkipButton && {
              label: formatMessage({
                id: 'shopping.page.businessExperience.secondaryAction.label'
              }),
              clickstreamProps: {
                elementName: 'business_experience_secondary_action'
              },
              'data-testid': 'business-experience-secondary-action',
              onClick: handleOnClick
            }
          }
          value={businessInfo.businessExperience}
        />
      </TwoColumnLayout.SmallColumn>
      <TwoColumnLayout.LargeColumn>
        <Stack spacing={2}>
          <CalloutAsset
            alt="business experience"
            name="funnel-questionnaire-experience"
            show={!isMobile}
            {...calloutAssetProps}
          />
        </Stack>
      </TwoColumnLayout.LargeColumn>
    </TwoColumnLayout>
  );
}

BusinessExperience.propTypes = {
  calloutAssetProps: PropTypes.object,
  showSubTitle: PropTypes.bool,
  hideSkipButton: PropTypes.bool
};

export default BusinessExperience;
